module.exports = __webpack_public_path__ + "static/logo-9c8f01bdfb36264e61a8ca72c10cb8b3.png";